import React from 'react'
import AdminInvoiceFilterRowContainer from '../../containers/admin/adminInvoiceFilterRow.container'
import ReactPaginate from 'react-paginate'
import { Translation } from 'react-i18next'
import FontAwesome from 'react-fontawesome'
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  Checkbox,
  Divider,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  IconButton,
  Collapse,
  LinearProgress
} from '@material-ui/core'
import {
  convertIntToState,
  convertNameToState,
  compareDatesToLogic
} from '../../utils/invoice.utils'
import DateTimeFormat from '../../utils/DateTimeFormat'
import { ADMIN_INVOICE_PAGE_SIZE } from '../../constants/index'
import {
  useForm,
  filterEmpty,
  addDynamicForm,
  deleteDynamicForm,
  updateFormValues
} from '../../form'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'

//excel
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'

import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons'
import AdminInvoiceFormContainer from '../../containers/admin/adminInvoiceForm.container'
import { useDispatch, useSelector } from 'react-redux'
import RemoveInvoiceFeeDialog from './removeInvoiceFeeDialog.component'

const defaultValues = {
  user_email: '',
  company_name: '',
  invoice_id: '',
  referencenumber: '',
  firstname: '',
  instant_payment: false,
  overdue: false,
  country: false,
  is_manual_pay: false,
  startdate: null,
  enddate: null,
  paymentdate: null,
  status: '',
  yearSelect: `${new Date().getFullYear()}`,
  adminInvoicePageSize: ADMIN_INVOICE_PAGE_SIZE
}

const InvoicePanel = ({
  classes,
  invoiceSearchRows,
  invoiceSearchPages,
  searchAdminInvoice,
  searchInvoiceSummary,
  selected,
  isToPay,
  isToPayInvoiceId,
  isInvoiceUnclear,
  isLahetetty,
  isReklamoitu,
  isPerinnassa,
  isMuokattu,
  isAdminSent,
  isAdminRejected,
  isAdminHalfPaid,
  shouldCloseInvoiceForms,
  showInvoicePDF,
  updateAdminInvoiceStatusToPerinnassa,
  expandAdminInvoice,
  showReminderInvoicePDF,
  warnInvoiceToPay,
  noPikapalkka,
  cancelUpdateAdminInvoiceStatus,
  closeDialog,
  updateAdminInvoiceStatusToRejected,
  updateAdminInvoiceStatusToNew,
  updateAdminInvoiceStatusToLoaned,
  sentInvoiceReminder,
  adminInvoicePageSize,
  shouldUpdateTable,
  updateAdminTableSuccess,
  allInvoiceInMonthSearch,
  isReminderActive,
  removeInvoiceFeeWithReason,
  showRemoveInvoiceFeeDialog,
  cancelRemoveInvoiceFeeDialog,
  feeType,
  invoiceNotes,
  is_group_invoice
}) => {
  // Global state to handle selected invoice expand row
  const [selectedInvoice, setSelectedInvoice] = React.useState(null)
  const [open, setOpen] = React.useState(false)
  const [isManualMaksettu, setIsManualMaksettu] = React.useState(false)

  const form = useForm({
    name: 'adminSearchInvoice',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    resetOnSubmit: false
  })

  const { getValues } = form

  const dispatch = useDispatch()

  function onSubmit(values) {
    searchAdminInvoice(null, true, values)
  }

  function handlePageChange(e) {
    searchAdminInvoice(e, true, filterEmpty(getValues()))
  }

  function handleExpand(e, el, isMaksettuAction = false) {
    const { invoice_id, partial_invoice_id, uuid } = el.values

    if (open) {
      dispatch(deleteDynamicForm('adminInvoiceForm' + el.index))
    }

    expandAdminInvoice(e, invoice_id, partial_invoice_id, uuid)
    dispatch(addDynamicForm('adminInvoiceForm' + el.index))
    setOpen(!open)
    setIsManualMaksettu(isMaksettuAction)
    setSelectedInvoice({ values: el.values, index: el.index })
  }

  React.useEffect(() => {
    if (shouldUpdateTable) {
      searchAdminInvoice({ selected: selected }, true, filterEmpty(getValues()))
      updateAdminTableSuccess()
    }
  }, [shouldUpdateTable])

  // KAS-337 take startdate and enddate values
  const startDate = getValues('startdate')
  const endDate = getValues('enddate')

  return (
    <Translation>
      {(t) => {
        return (
          <div className="col-xs-12 col-sm-12 col-lg-12">
            <div className="panel panel-default">
              <div className="panel-body">
                <AdminInvoiceFilterRowContainer form={form} />
              </div>
              <hr style={{ marginTop: '0px' }} />
              <div className="panel-body">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        className={classes.tableHead}
                        style={{
                          width: '70px',
                          paddingLeft: '10px',
                          paddingRight: '10px'
                        }}
                      >
                        Etunimi
                      </TableCell>
                      <TableCell
                        className={classes.tableHead}
                        style={{
                          width: '70px',
                          paddingLeft: '10px',
                          paddingRight: '10px'
                        }}
                      >
                        Sukunimi
                      </TableCell>
                      <TableCell
                        className={classes.tableHead}
                        style={{
                          width: '120px',
                          paddingLeft: '10px',
                          paddingRight: '10px'
                        }}
                      >
                        Sähköposti
                      </TableCell>
                      <TableCell
                        className={classes.tableHead}
                        style={{
                          width: '70px',
                          paddingLeft: '10px',
                          paddingRight: '10px'
                        }}
                      >
                        Toimitustapa
                      </TableCell>
                      <TableCell
                        className={classes.tableHead}
                        style={{
                          width: '70px',
                          paddingLeft: '10px',
                          paddingRight: '10px'
                        }}
                      >
                        Yrityksen nimi
                      </TableCell>
                      <TableCell
                        className={classes.tableHead}
                        style={{
                          width: '40px',
                          paddingLeft: '5px',
                          paddingRight: '5px'
                        }}
                      >
                        Maa
                      </TableCell>
                      <TableCell
                        className={classes.tableHead}
                        style={{
                          width: '80px',
                          paddingLeft: '10px',
                          paddingRight: '10px',
                          textAlign: 'right'
                        }}
                      >
                        Laskunro
                      </TableCell>
                      <TableCell
                        className={classes.tableHead}
                        style={{
                          width: '70px',
                          paddingLeft: '10px',
                          paddingRight: '10px',
                          textAlign: 'right'
                        }}
                      >
                        Laskuviite
                      </TableCell>
                      <TableCell
                        className={classes.tableHead}
                        style={{
                          width: '80px',
                          paddingLeft: '10px',
                          paddingRight: '10px',
                          textAlign: 'right'
                        }}
                      >
                        Summa
                      </TableCell>
                      <TableCell
                        className={classes.tableHead}
                        style={{
                          width: '80px',
                          paddingLeft: '10px',
                          paddingRight: '10px',
                          textAlign: 'right'
                        }}
                      >
                        Avoinsumma
                      </TableCell>
                      <TableCell
                        className={classes.tableHead}
                        style={{
                          width: '70px',
                          paddingLeft: '8px',
                          paddingRight: '8px',
                          textAlign: 'right'
                        }}
                      >
                        Eräpäivä
                      </TableCell>
                      <TableCell
                        className={classes.tableHead}
                        style={{
                          width: '70px',
                          paddingLeft: '8px',
                          paddingRight: '8px',
                          textAlign: 'right'
                        }}
                      >
                        Maksupäivä
                      </TableCell>
                      <TableCell
                        className={classes.tableHead}
                        style={{
                          width: '40px',
                          paddingLeft: '5px',
                          paddingRight: '10px'
                        }}
                      >
                        Pikapalk
                      </TableCell>
                      <TableCell
                        className={classes.tableHead}
                        style={{
                          width: '50px',
                          paddingLeft: '10px',
                          paddingRight: '10px'
                        }}
                      >
                        Pptila
                      </TableCell>
                      <TableCell
                        className={classes.tableHead}
                        style={{
                          width: '50px',
                          paddingLeft: '10px',
                          paddingRight: '10px'
                        }}
                      >
                        Mtila
                      </TableCell>
                      <TableCell
                        className={classes.tableHead}
                        style={{
                          width: '50px',
                          paddingLeft: '5px',
                          paddingRight: '5px'
                        }}
                      >
                        Muistutus
                      </TableCell>
                      <TableCell
                        className={classes.tableHead}
                        style={{
                          width: '70px',
                          paddingLeft: '10px',
                          paddingRight: '10px'
                        }}
                      >
                        Tila
                      </TableCell>
                      <TableCell
                        className={classes.tableHead}
                        style={{
                          width: '80px',
                          paddingLeft: '10px',
                          paddingRight: '10px'
                        }}
                      >
                        Lasku maksettu
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {createInvoiceRow(
                      t,
                      classes,
                      invoiceSearchRows,
                      selected,
                      isToPayInvoiceId,
                      showInvoicePDF,
                      updateAdminInvoiceStatusToPerinnassa,
                      handleExpand,
                      showReminderInvoicePDF,
                      warnInvoiceToPay,
                      sentInvoiceReminder,
                      adminInvoicePageSize,
                      shouldCloseInvoiceForms,
                      selectedInvoice,
                      setSelectedInvoice,
                      setOpen,
                      open,
                      isManualMaksettu
                    )}
                  </TableBody>
                </Table>
                <Divider />
                <ReactPaginate
                  previousLabel={<i className="fa fa-chevron-left" />}
                  nextLabel={<i className="fa fa-chevron-right" />}
                  breakLabel={'...'}
                  breakClassName={'break-me'}
                  pageCount={invoiceSearchPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageChange}
                  containerClassName={'pagination'}
                  subContainerClassName={'pages pagination'}
                  activeClassName={'active'}
                  forcePage={invoiceSearchPages === 0 ? undefined : selected}
                  //Huy kas-197
                />
                {/* Invoice Excel Download */}
                {createInvoicesExcelReportButton(
                  t,
                  invoiceSearchRows,
                  searchInvoiceSummary,
                  selected,
                  adminInvoicePageSize,
                  startDate,
                  endDate,
                  allInvoiceInMonthSearch
                )}
                <Dialog
                  open={isToPay}
                  onClose={() => {
                    closeDialog()
                    setTimeout(cancelUpdateAdminInvoiceStatus, 150)
                  }}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="alert-dialog-title">
                    <span style={{ fontSize: '20px' }}>
                      {'Vahvista laskun maksu'}
                    </span>
                  </DialogTitle>
                  <DialogActions>
                    {isInvoiceUnclear ||
                    isMuokattu ||
                    isAdminSent ||
                    isAdminHalfPaid ||
                    isAdminRejected ? (
                      <ul className="nav nav-pills pull-right">
                        <li>
                          <Button
                            style={{ margin: '10px' }}
                            onClick={(e) => {
                              closeDialog()
                              handleExpand(e, selectedInvoice, true)
                            }}
                            variant="contained"
                          >
                            Maksettu
                          </Button>
                        </li>
                        {isReminderActive && (
                          <li>
                            <Button
                              style={{ margin: '10px', whiteSpace: 'nowrap' }}
                              onClick={() => {
                                dispatch(
                                  updateFormValues('removeInvoiceFeeForm', {
                                    notes: invoiceNotes
                                  })
                                )
                                closeDialog()
                                removeInvoiceFeeWithReason('remind')
                              }}
                              variant="contained"
                            >
                              Maksettu, poista muistutus
                            </Button>
                          </li>
                        )}
                        <li>
                          <Button
                            style={{ margin: '10px' }}
                            onClick={() => {
                              closeDialog()
                              isAdminSent || isAdminHalfPaid || isAdminRejected
                                ? setTimeout(
                                    updateAdminInvoiceStatusToNew,
                                    150,
                                    20
                                  )
                                : setTimeout(
                                    updateAdminInvoiceStatusToRejected,
                                    150
                                  )
                            }}
                            variant="contained"
                          >
                            Hylätty
                          </Button>
                        </li>
                        <li>
                          <Button
                            style={{ margin: '10px' }}
                            onClick={() => {
                              closeDialog()
                              setTimeout(cancelUpdateAdminInvoiceStatus, 150)
                            }}
                            variant="contained"
                          >
                            Peruuta
                          </Button>
                        </li>
                      </ul>
                    ) : isPerinnassa ? (
                      <ul className="nav nav-pills pull-right">
                        <li>
                          <Button
                            style={{ margin: '10px' }}
                            onClick={(e) => {
                              closeDialog()
                              handleExpand(e, selectedInvoice, true)
                            }}
                            variant="contained"
                          >
                            Maksettu
                          </Button>
                        </li>
                        {isReminderActive && (
                          <li>
                            <Button
                              style={{ margin: '10px', whiteSpace: 'nowrap' }}
                              onClick={() => {
                                dispatch(
                                  updateFormValues('removeInvoiceFeeForm', {
                                    notes: invoiceNotes
                                  })
                                )
                                closeDialog()
                                removeInvoiceFeeWithReason('recover')
                              }}
                              variant="contained"
                            >
                              Poista perinnästä
                            </Button>
                          </li>
                        )}
                        <li>
                          <Button
                            style={{ margin: '10px' }}
                            onClick={() => {
                              closeDialog()
                              setTimeout(updateAdminInvoiceStatusToNew, 150, 12)
                            }}
                            variant="contained"
                          >
                            P Hylätty
                          </Button>
                        </li>
                        <li>
                          <Button
                            style={{ margin: '10px' }}
                            onClick={() => {
                              closeDialog()
                              setTimeout(updateAdminInvoiceStatusToNew, 150, 10)
                            }}
                            variant="contained"
                          >
                            Reklamoitu
                          </Button>
                        </li>
                        <li>
                          <Button
                            style={{ margin: '10px' }}
                            onClick={() => {
                              closeDialog()
                              setTimeout(cancelUpdateAdminInvoiceStatus, 150)
                            }}
                            variant="contained"
                          >
                            Peruuta
                          </Button>
                        </li>
                      </ul>
                    ) : isReklamoitu ? (
                      <ul className="nav nav-pills pull-right">
                        <li>
                          <Button
                            style={{ margin: '10px' }}
                            onClick={(e) => {
                              closeDialog()
                              handleExpand(e, selectedInvoice, true)
                            }}
                            variant="contained"
                          >
                            Maksettu
                          </Button>
                        </li>
                        {isReminderActive && (
                          <li>
                            <Button
                              style={{ margin: '10px', whiteSpace: 'nowrap' }}
                              onClick={() => {
                                dispatch(
                                  updateFormValues('removeInvoiceFeeForm', {
                                    notes: invoiceNotes
                                  })
                                )
                                closeDialog()
                                removeInvoiceFeeWithReason('recover')
                              }}
                              variant="contained"
                            >
                              Poista perinnästä
                            </Button>
                          </li>
                        )}
                        <li>
                          <Button
                            style={{ margin: '10px' }}
                            onClick={() => {
                              closeDialog()
                              setTimeout(updateAdminInvoiceStatusToNew, 150, 12)
                            }}
                            variant="contained"
                          >
                            P Hylätty
                          </Button>
                        </li>
                        <li>
                          <Button
                            style={{ margin: '10px' }}
                            onClick={() => {
                              closeDialog()
                              setTimeout(cancelUpdateAdminInvoiceStatus, 150)
                            }}
                            variant="contained"
                          >
                            Peruuta
                          </Button>
                        </li>
                      </ul>
                    ) : isLahetetty ? (
                      <ul className="nav nav-pills pull-right">
                        <li>
                          <Button
                            style={{ margin: '10px' }}
                            onClick={(e) => {
                              closeDialog()
                              handleExpand(e, selectedInvoice, true)
                            }}
                            variant="contained"
                          >
                            Maksettu
                          </Button>
                        </li>
                        {isReminderActive && (
                          <li>
                            <Button
                              style={{ margin: '10px', whiteSpace: 'nowrap' }}
                              onClick={() => {
                                dispatch(
                                  updateFormValues('removeInvoiceFeeForm', {
                                    notes: invoiceNotes
                                  })
                                )
                                closeDialog()
                                removeInvoiceFeeWithReason('remind')
                              }}
                              variant="contained"
                            >
                              Maksettu, poista muistutus
                            </Button>
                          </li>
                        )}
                        <li>
                          <Button
                            style={{ margin: '10px' }}
                            onClick={() => {
                              closeDialog()
                              setTimeout(
                                updateAdminInvoiceStatusToRejected,
                                150
                              )
                            }}
                            variant="contained"
                          >
                            Hylätty
                          </Button>
                        </li>
                        <li>
                          <Button
                            style={{ margin: '10px' }}
                            onClick={() => {
                              closeDialog()
                              setTimeout(updateAdminInvoiceStatusToLoaned, 150)
                            }}
                            variant="contained"
                            disabled={is_group_invoice}
                          >
                            Rahoitettu
                          </Button>
                        </li>
                        <li>
                          <Button
                            style={{ margin: '10px' }}
                            onClick={() => {
                              closeDialog()
                              setTimeout(noPikapalkka, 150, true)
                            }}
                            variant="contained"
                            disabled={is_group_invoice}
                          >
                            Ei Pikapalkka
                          </Button>
                        </li>
                        <li>
                          <Button
                            style={{ margin: '10px' }}
                            onClick={() => {
                              closeDialog()
                              setTimeout(noPikapalkka, 150, false)
                            }}
                            variant="contained"
                            disabled={is_group_invoice}
                          >
                            Pikapalkka
                          </Button>
                        </li>
                        <li>
                          <Button
                            style={{ margin: '10px' }}
                            onClick={() => {
                              closeDialog()
                              setTimeout(updateAdminInvoiceStatusToNew, 150, 11)
                            }}
                            variant="contained"
                          >
                            Keskeytetty
                          </Button>
                        </li>
                        <li>
                          <Button
                            style={{ margin: '10px' }}
                            onClick={() => {
                              closeDialog()
                              setTimeout(cancelUpdateAdminInvoiceStatus, 150)
                            }}
                            variant="contained"
                          >
                            Peruuta
                          </Button>
                        </li>
                      </ul>
                    ) : (
                      <ul className="nav nav-pills pull-right">
                        <li>
                          <Button
                            style={{ margin: '10px' }}
                            onClick={(e) => {
                              closeDialog()
                              handleExpand(e, selectedInvoice, true)
                            }}
                            variant="contained"
                          >
                            Maksettu
                          </Button>
                        </li>
                        {isReminderActive && (
                          <li>
                            <Button
                              style={{ margin: '10px', whiteSpace: 'nowrap' }}
                              onClick={() => {
                                dispatch(
                                  updateFormValues('removeInvoiceFeeForm', {
                                    notes: invoiceNotes
                                  })
                                )
                                closeDialog()
                                removeInvoiceFeeWithReason('remind')
                              }}
                              variant="contained"
                            >
                              Maksettu, poista muistutus
                            </Button>
                          </li>
                        )}
                        <li>
                          <Button
                            style={{ margin: '10px' }}
                            onClick={updateAdminInvoiceStatusToRejected}
                            variant="contained"
                          >
                            Hylätty
                          </Button>
                        </li>
                        <li>
                          <Button
                            style={{ margin: '10px' }}
                            onClick={updateAdminInvoiceStatusToLoaned}
                            variant="contained"
                            disabled={is_group_invoice}
                          >
                            Rahoitettu
                          </Button>
                        </li>
                        <li>
                          <Button
                            style={{ margin: '10px' }}
                            onClick={() => noPikapalkka(true)}
                            variant="contained"
                            disabled={is_group_invoice}
                          >
                            Ei Pikapalkka
                          </Button>
                        </li>
                        <li>
                          <Button
                            style={{ margin: '10px' }}
                            onClick={() => noPikapalkka(false)}
                            variant="contained"
                            disabled={is_group_invoice}
                          >
                            Pikapalkka
                          </Button>
                        </li>
                        <li>
                          <Button
                            style={{ margin: '10px' }}
                            onClick={() => {
                              closeDialog()
                              setTimeout(cancelUpdateAdminInvoiceStatus, 150)
                            }}
                            variant="contained"
                          >
                            Peruuta
                          </Button>
                        </li>
                      </ul>
                    )}
                  </DialogActions>
                </Dialog>
                <Dialog
                  open={showRemoveInvoiceFeeDialog}
                  onClose={() => {
                    cancelRemoveInvoiceFeeDialog()
                  }}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogActions>
                    <RemoveInvoiceFeeDialog
                      cancelDialog={cancelRemoveInvoiceFeeDialog}
                      feeType={feeType}
                      updateAdminInvoiceStatusToNew={
                        updateAdminInvoiceStatusToNew
                      }
                    />
                  </DialogActions>
                </Dialog>
                <Table>
                  <TableHead>
                    <TableRow />
                    <TableRow>
                      <TableCell className={classes.tableCell} />
                      <TableCell className={classes.tableCell} align="right">
                        Yhteensä (veroton)
                      </TableCell>
                      <TableCell className={classes.tableCell} align="right">
                        Alv
                      </TableCell>
                      <TableCell className={classes.tableCell} align="right">
                        Yhteensä
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell className={classes.tableCell} align="left">
                        Myynti
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(searchInvoiceSummary.sum_without_tax)}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(searchInvoiceSummary.total_vat)}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(searchInvoiceSummary.sum_with_tax)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="left"
                      >
                        Myynti Pikapalkka
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(
                          searchInvoiceSummary.sum_quick_pay_without_tax
                        )}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(searchInvoiceSummary.total_quick_pay_vat)}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(searchInvoiceSummary.sum_quick_pay_with_tax)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="left"
                      >
                        Myynti Tapaturmavakuutus
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(
                          searchInvoiceSummary.sum_vakuutus_without_tax
                        )}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(searchInvoiceSummary.total_vakuutus_vat)}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(searchInvoiceSummary.sum_vakuutus_with_tax)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCell} align="left">
                        Myynti 25,5%
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(searchInvoiceSummary.sum_without_25_5_tax)}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(searchInvoiceSummary.sum_25_5_vat)}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(searchInvoiceSummary.sum_with_25_5_tax)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCell} align="left">
                        Myynti 24%
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(searchInvoiceSummary.sum_without_24_tax)}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(searchInvoiceSummary.sum_24_vat)}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(searchInvoiceSummary.sum_with_24_tax)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCell} align="left">
                        Myynti 14%
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(searchInvoiceSummary.sum_without_14_tax)}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(searchInvoiceSummary.sum_14_vat)}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(searchInvoiceSummary.sum_with_14_tax)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCell} align="left">
                        Myynti 10%
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(searchInvoiceSummary.sum_without_10_tax)}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(searchInvoiceSummary.sum_10_vat)}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(searchInvoiceSummary.sum_with_10_tax)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCell} align="left">
                        Myynti 0%
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(searchInvoiceSummary.sum_without_0_tax)}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(0)}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(searchInvoiceSummary.sum_with_0_tax)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="left"
                      >
                        Rakennusalan myynti 0%
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(
                          searchInvoiceSummary.sum_building_construction_0_tax
                        )}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(0)}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                        align="right"
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(
                          searchInvoiceSummary.sum_building_construction_0_tax
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow />
                  </TableBody>
                </Table>
              </div>
            </div>
          </div>
        )
      }}
    </Translation>
  )
}

const createInvoiceRow = (
  t,
  classes,
  invoices,
  selected,
  isToPayInvoiceId,
  showInvoicePDF,
  updateAdminInvoiceStatusToPerinnassa,
  handleExpand,
  showReminderInvoicePDF,
  warnInvoiceToPay,
  sentInvoiceReminder,
  adminInvoicePageSize,
  shouldCloseInvoiceForms,
  selectedInvoice,
  setSelectedInvoice,
  setOpen,
  open,
  isManualMaksettu
) => {
  return invoices
    .slice(
      selected * adminInvoicePageSize,
      selected * adminInvoicePageSize + adminInvoicePageSize
    )
    .map((el, index) => (
      <InvoiceAdminRow
        t={t}
        classes={classes}
        el={el}
        index={index}
        key={index}
        pageIndex={selected}
        isToPayInvoiceId={isToPayInvoiceId}
        showInvoicePDF={showInvoicePDF}
        updateAdminInvoiceStatusToPerinnassa={
          updateAdminInvoiceStatusToPerinnassa
        }
        handleExpand={handleExpand}
        showReminderInvoicePDF={showReminderInvoicePDF}
        warnInvoiceToPay={warnInvoiceToPay}
        sentInvoiceReminder={sentInvoiceReminder}
        shouldCloseInvoiceForms={shouldCloseInvoiceForms}
        selectedInvoice={selectedInvoice}
        setSelectedInvoice={setSelectedInvoice}
        setOpen={setOpen}
        open={open}
        isManualMaksettu={isManualMaksettu}
      />
    ))
}

const InvoiceAdminRow = ({
  t,
  classes,
  el,
  index,
  pageIndex,
  isToPayInvoiceId,
  showInvoicePDF,
  updateAdminInvoiceStatusToPerinnassa,
  handleExpand,
  showReminderInvoicePDF,
  warnInvoiceToPay,
  sentInvoiceReminder,
  shouldCloseInvoiceForms,
  selectedInvoice,
  setSelectedInvoice,
  setOpen,
  open,
  isManualMaksettu
}) => {
  const showPartialInvoiceLoader = useSelector(
    (state) => state.loader.showPartialInvoiceLoader
  )

  const dispatch = useDispatch()

  // Close expanded invoice row when search invoice
  React.useEffect(() => {
    if (shouldCloseInvoiceForms && open) {
      setOpen(false)
      dispatch(deleteDynamicForm('adminInvoiceForm' + index))
    }
  }, [shouldCloseInvoiceForms, setOpen])

  React.useEffect(() => {
    if (open) {
      setOpen(false)
      dispatch(deleteDynamicForm('adminInvoiceForm' + index))
    }
  }, [pageIndex, setOpen])

  return (
    <>
      <TableRow key={el.uuid}>
        <TableCell
          className={classes.tableCell}
          style={{
            width: '70px',
            paddingLeft: '10px',
            paddingRight: '10px'
          }}
        >
          {el.firstname}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            width: '70px',
            paddingLeft: '10px',
            paddingRight: '10px'
          }}
        >
          {el.lastname}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            width: '120px',
            paddingLeft: '10px',
            paddingRight: '10px',
            whiteSpace: 'normal',
            wordWrap: 'break-word'
          }}
        >
          {el.email}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{ width: '70px', paddingLeft: '10px', paddingRight: '10px' }}
        >
          {el.delivery_method}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            width: '70px',
            paddingLeft: '10px',
            paddingRight: '10px',
            whiteSpace: 'normal',
            wordWrap: 'break-word'
          }}
        >
          {el.company_name}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            //Huy Kas-194
            width: '60px',
            paddingLeft: '5px',
            paddingRight: '5px',
            whiteSpace: 'normal',
            wordWrap: 'break-word'
          }}
        >
          {t(`countryList.${el.country}`)}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            width: '40px',
            paddingLeft: '10px',
            paddingRight: '10px',
            textAlign: 'right'
          }}
        >
          {el.modified_invoices}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            width: '65px',
            paddingLeft: '10px',
            paddingRight: '10px',
            textAlign: 'right'
          }}
        >
          {el.referencenumber}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            width: '80px',
            paddingLeft: '10px',
            paddingRight: '10px',
            textAlign: 'right'
          }}
        >
          {new Intl.NumberFormat('fi-FI', {
            style: 'currency',
            currency: 'EUR'
          }).format(el.original_sum)}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            width: '80px',
            paddingLeft: '10px',
            paddingRight: '10px',
            textAlign: 'right'
          }}
        >
          {new Intl.NumberFormat('fi-FI', {
            style: 'currency',
            currency: 'EUR'
          }).format(el.sum)}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            width: '54px',
            paddingLeft: '8px',
            paddingRight: '8px',
            textAlign: 'right'
          }}
        >
          {new DateTimeFormat('fi', {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric'
          }).format(new Date(el.due_date))}
        </TableCell>

        {el.paymentdate !== null ? (
          <TableCell
            className={classes.tableCell}
            style={{
              width: '54px',
              paddingLeft: '8px',
              paddingRight: '8px',
              textAlign: 'right'
            }}
          >
            {new DateTimeFormat('fi', {
              day: 'numeric',
              month: 'numeric',
              year: 'numeric'
            }).format(new Date(el.paymentdate))}
          </TableCell>
        ) : (
          <TableCell
            className={classes.tableCell}
            style={{ width: '54px', paddingLeft: '8px', paddingRight: '8px' }}
          >
            {' '}
          </TableCell>
        )}
        <TableCell
          className={classes.tableCell}
          style={{ width: '35px', paddingLeft: '5px', paddingRight: '10px' }}
        >
          <Checkbox
            checked={el.instant_payment === 'quick_pay' ? true : false}
            disabled={true}
            size="medium"
            icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
            checkedIcon={<CheckBoxIcon fontSize="large" />}
          />
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            width: '57px',
            paddingLeft: '10px',
            paddingRight: '10px',
            whiteSpace: 'normal',
            wordWrap: 'break-word'
          }}
        >
          {convertNameToState(el.QPstatus)}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            width: '57px',
            paddingLeft: '10px',
            paddingRight: '10px',
            whiteSpace: 'normal',
            wordWrap: 'break-word'
          }}
        >
          {convertNameToState(el.admin_fee_status)}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{ width: '40px', paddingLeft: '5px', paddingRight: '5px' }}
        >
          <Checkbox
            checked={el.is_payment_control}
            disabled={true}
            icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
            checkedIcon={<CheckBoxIcon fontSize="large" />}
          />
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            width: '57px',
            paddingLeft: '10px',
            paddingRight: '10px',
            whiteSpace: 'normal',
            wordWrap: 'break-word'
          }}
        >
          {convertIntToState(el.status)} {
            el.is_manual_pay ? ' (M)' : ''
          }
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{ width: '85px', paddingLeft: '10px', paddingRight: '10px' }}
        >
          <div style={{ display: 'flex' }}>
            <Checkbox
              style={{ width: '15px' }}
              onClick={() => {
                if (open) setOpen(false)
                setSelectedInvoice({ values: el, index })
                warnInvoiceToPay(
                  `${el.uuid}$$${el.invoice_id}$$${el.instant_payment}$$${el.status}$$${el.due_date}$$${el.remindersent}$$${el.notes}$$${el.is_group_invoice}$$${el.is_payment_control}`
                )
              }}
              disabled={
                //(convertIntToState(el.status) === 'Maksettu') || (convertIntToState(el.status) === 'Ei nostettu') || (convertIntToState(el.status) === 'Perinnässä')
                el.status === 2 ||
                el.status === 18 ||
                el.status === 6 ||
                el.status === 12 ||
                el.status === 15 ||
                el.status === 21 ||
                el.status === 22 ||
                el.status === 24 ||
                el.sum < 0
                  ? true
                  : false
              }
              checked={
                isToPayInvoiceId !==
                `${el.uuid}$$${el.invoice_id}$$${el.instant_payment}$$${el.partial_invoice_id}`
                  ? false
                  : true
              }
              icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
              checkedIcon={
                <CheckBoxIcon fontSize="large" style={{ fill: '#F67131' }} />
              }
            />
            <p
              style={{ marginLeft: '8px', marginTop: '12px' }}
              onClick={() => {
                showInvoicePDF(`${el.uuid}$$${el.invoice_id}`)
              }}
              className="link"
            >
              <FontAwesome
                name="file-pdf-o"
                title="Laskujen tallennus PDF-tiedostoiksi"
              />
            </p>
            {el.is_payment_control &&
            new Date(el.due_date) < new Date() &&
            el.remindersent === 0 &&
            !/^-\d*\.?\,?\d+$/i.test(el.sum) &&
            compareDatesToLogic(
              el.due_date,
              'remind',
              el.remindersent,
              el.customer_type
            ) &&
            (el.status === 1 ||
              el.status === 3 ||
              el.status === 5 ||
              el.status === 13) ? (
              <p
                style={{
                  marginLeft: '8px',
                  color: '#ff9900',
                  marginTop: '12px'
                }}
                onClick={() => {
                  sentInvoiceReminder(`${el.uuid}$$${el.invoice_id}`)
                }}
                className="link"
              >
                <FontAwesome name="fal fa-bell" title="Muistutus aktiivinen" />
              </p>
            ) : el.is_payment_control &&
              new Date(el.due_date) >= new Date() &&
              el.remindersent === 0 &&
              /^-\d*\.?\,?\d+$/i.test(el.sum) &&
              compareDatesToLogic(
                el.due_date,
                'remind',
                el.remindersent,
                el.customer_type
              ) ? (
              <p
                style={{ paddingTop: '12px', marginLeft: '8px', color: 'Gray' }}
              >
                <FontAwesome name="fal fa-bell" title="Muistutus passiivinen" />
              </p>
            ) : el.status === 11 && el.remindersent === 0 ? (
              <p
                style={{ paddingTop: '12px', marginLeft: '8px', color: 'Gray' }}
              >
                <FontAwesome name="fal fa-bell" title="Muistutus passiivinen" />
              </p>
            ) : el.is_payment_control &&
              new Date(el.due_date) < new Date() &&
              el.remindersent === 1 &&
              el.status !== 17 ? (
              <p
                style={{ paddingTop: '12px', marginLeft: '8px', color: 'red' }}
              >
                <FontAwesome name="fal fa-bell" title="Muistutus lähetetty" />
              </p>
            ) : (
              <p
                style={{ paddingTop: '12px', marginLeft: '8px', color: 'Gray' }}
              >
                <FontAwesome name="fal fa-bell" title="Muistutus passiivinen" />
              </p>
            )}
            {compareDatesToLogic(
              el.status === 17 ? el.due_date : el.reminder_due_date,
              'recover',
              el.remindersent,
              el.customer_type
            ) &&
            (el.remindersent === 1 ||
              (el.remindersent === 0 &&
                el.status === 17 &&
                new Date(el.due_date) < new Date())) &&
            el.debt_collection_sent === false &&
            (el.status === 1 ||
              el.status === 3 ||
              el.status === 5 ||
              el.status === 13 ||
              el.status === 17) ? (
              <p
                style={{
                  marginLeft: '8px',
                  color: '#ff9900',
                  marginTop: '12px'
                }}
                onClick={() => {
                  updateAdminInvoiceStatusToPerinnassa(
                    `${el.uuid}$$${el.invoice_id}$$${el.partial_invoice_id}`
                  )
                }}
                className="link"
              >
                <FontAwesome
                  name="fas fa-exclamation"
                  title="Perintä aktiivinen"
                />
              </p>
            ) : el.status === 11 ? (
              <p
                style={{ marginLeft: '8px', color: 'Gray', marginTop: '12px' }}
                className="link"
              >
                <FontAwesome
                  name="fas fa-exclamation"
                  title="Perintä passiivinen"
                />
              </p>
            ) : el.debt_collection_sent === true ? (
              <p
                style={{ marginLeft: '8px', color: 'red', marginTop: '12px' }}
                className="link"
              >
                <FontAwesome
                  name="fas fa-exclamation"
                  title="Perintä lähetetty"
                />
              </p>
            ) : (
              <p
                style={{ marginLeft: '8px', color: 'Gray', marginTop: '12px' }}
                className="link"
              >
                <FontAwesome
                  name="fas fa-exclamation"
                  title="Perintä passiivinen"
                />
              </p>
            )}
            {el.remindersent == 1 ? (
              el.status != 2 ? (
                <p
                  style={{ marginLeft: '8px', marginTop: '12px' }}
                  className="link"
                  onClick={() => {
                    showReminderInvoicePDF(`${el.uuid}$$${el.invoice_id}`)
                  }}
                >
                  <FontAwesome
                    name="fas fa-sticky-note"
                    title="Tallenna muistutuslasku"
                  />
                </p>
              ) : null
            ) : null}
            <p>
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={(e) => handleExpand(e, { values: el, index })}
                style={{ marginLeft: '8px' }}
              >
                {open && selectedInvoice.index === index ? (
                  <KeyboardArrowUp fontSize="large" />
                ) : (
                  <KeyboardArrowDown fontSize="large" />
                )}
              </IconButton>
            </p>
          </div>
          {/*Loader dialog when update invoice*/}
          <Dialog
            open={showPartialInvoiceLoader}
            BackdropProps={{ style: { backgroundColor: 'transparent' } }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              <span style={{ fontSize: '20px' }}>{'Tietoja päivitetään'}</span>
            </DialogTitle>
            <DialogActions>
              <div style={{ flexGrow: 1 }}>
                <LinearProgress />
              </div>
            </DialogActions>
          </Dialog>
        </TableCell>
      </TableRow>
      {
        <TableRow style={{ height: '0px' }}>
          <TableCell
            style={{
              fontSize: '13px',
              borderBottom: '1px solid lightgray',
              padding: '0px 0px'
            }}
            colSpan={16}
          >
            <Collapse
              in={open && selectedInvoice.index === index}
              timeout="auto"
              unmountOnExit
            >
              <div style={{ padding: '20px', paddingTop: '40px' }}>
                {el.expanded &&
                  expandedInvoiceFormData(
                    el.expandData,
                    el.uuid,
                    el.base_invoice_id,
                    el.base_uuid,
                    index,
                    setOpen,
                    isManualMaksettu
                  )}
              </div>
            </Collapse>
          </TableCell>
        </TableRow>
      }
    </>
  )
}

// Expanded invoice row
const expandedInvoiceFormData = (
  expandData,
  uuid,
  base_invoice_id,
  base_uuid,
  index,
  setOpen,
  isManualMaksettu
) => (
  <AdminInvoiceFormContainer
    initialValues={expandData}
    uuid={uuid}
    base_invoice_id={base_invoice_id}
    base_uuid={base_uuid}
    index={index}
    setOpen={setOpen}
    isManualMaksettu={isManualMaksettu}
  />
)

const createInvoicesExcelReportButton = (
  t,
  invoices = [],
  summary = {},
  selected,
  adminInvoicePageSize,
  startDate,
  endDate,
  allInvoiceInMonthSearch
) => {
  if (invoices.length <= 0) {
    return
  }

  // Table Columns
  const invoicesColumns = [
    {
      name: 'Sähköposti',
      filterButton: true
    },
    {
      name: 'Toimitustapa',
      filterButton: true
    },
    {
      name: 'Yrityksen nimi',
      filterButton: true
    },
    {
      name: 'Maa',
      filterButton: true
    },
    {
      name: 'Laskunro',
      filterButton: true
    },
    {
      name: 'Laskuviite',
      filterButton: true
    },
    {
      name: 'Summa',
      filterButton: true
    },
    {
      name: 'Avoinsumma',
      filterButton: true
    },
    {
      name: 'Eräpäivä',
      filterButton: true
    },
    {
      name: 'Maksupäivä',
      filterButton: true
    },
    {
      name: 'Pikapalk',
      filterButton: true
    },
    {
      name: 'Pptila',
      filterButton: true
    },
    {
      name: 'Mtila',
      filterButton: true
    },
    {
      name: 'Muistutus',
      filterButton: true
    },
    {
      name: 'Tila',
      filterButton: true
    }
  ]

  const summaryColumns = [
    { name: 'Title', filterButton: true },
    { name: 'Yhtensä (veroton)', filterButton: true },
    { name: 'Alv', filterButton: true },
    { name: 'Yhtensää', filterButton: true }
  ]

  // Table rows
  // KAS-337 If month is searched, it will download excel with all the invoices, no need to jump to last page to call all invoices to download
  // KAS-337 If month search is missing, download excel acting normally
  const invoicesRows =
    (startDate !== null && endDate !== null) || endDate !== null // PI-295 download all invoice records when Loppupvm is searched
      ? allInvoiceInMonthSearch.map((invoice) => {
          return [
            invoice.email,
            invoice.delivery_method,
            invoice.company_name,
            t(`countryList.${invoice.country}`),
            invoice.modified_invoices,
            invoice.referencenumber,
            invoice.original_sum,
            invoice.sum,
            new DateTimeFormat('fi', {
              day: 'numeric',
              month: 'numeric',
              year: 'numeric'
            }).format(new Date(invoice.due_date)),
            invoice.paymentdate
              ? new DateTimeFormat('fi', {
                  day: 'numeric',
                  month: 'numeric',
                  year: 'numeric'
                }).format(new Date(invoice.paymentdate))
              : '',
            invoice.instant_payment === 'quick_pay' ? 'True' : 'False',
            invoice.QPstatus ? convertNameToState(invoice.QPstatus) : '',
            invoice.admin_fee_status
              ? convertNameToState(invoice.admin_fee_status)
              : '',
            invoice.is_payment_control ? 'True' : 'False',
            convertIntToState(invoice.status)
          ]
        })
      : invoices
          .slice(0, selected * adminInvoicePageSize + adminInvoicePageSize)
          .map((invoice) => {
            return [
              invoice.email,
              invoice.delivery_method,
              invoice.company_name,
              t(`countryList.${invoice.country}`),
              invoice.modified_invoices,
              invoice.referencenumber,
              invoice.original_sum,
              invoice.sum,
              new DateTimeFormat('fi', {
                day: 'numeric',
                month: 'numeric',
                year: 'numeric'
              }).format(new Date(invoice.due_date)),
              invoice.paymentdate
                ? new DateTimeFormat('fi', {
                    day: 'numeric',
                    month: 'numeric',
                    year: 'numeric'
                  }).format(new Date(invoice.paymentdate))
                : '',
              invoice.instant_payment === 'quick_pay' ? 'True' : 'False',
              invoice.QPstatus ? convertNameToState(invoice.QPstatus) : '',
              invoice.admin_fee_status
                ? convertNameToState(invoice.admin_fee_status)
                : '',
              invoice.is_payment_control ? 'True' : 'False',
              convertIntToState(invoice.status)
            ]
          })

  const summaryRows = [
    [
      'Myynti',
      summary.sum_without_tax ? summary.sum_without_tax : 0,
      summary.total_vat ? summary.total_vat : 0,
      summary.sum_with_tax ? summary.sum_with_tax : 0
    ],
    [
      'Myynti Pikapalkka',
      summary.sum_quick_pay_without_tax ? summary.sum_quick_pay_without_tax : 0,
      summary.total_quick_pay_vat ? summary.total_quick_pay_vat : 0,
      summary.sum_quick_pay_with_tax ? summary.sum_quick_pay_with_tax : 0
    ],
    [
      'Myynti Tapaturmavakuutus',
      summary.sum_vakuutus_without_tax ? summary.sum_vakuutus_without_tax : 0,
      summary.total_vakuutus_vat ? summary.total_vakuutus_vat : 0,
      summary.sum_vakuutus_with_tax ? summary.sum_vakuutus_with_tax : 0
    ],
    [
      'Myynti 25,5%',
      summary.sum_without_25_5_tax ? summary.sum_without_25_5_tax : 0,
      summary.sum_25_5_vat ? summary.sum_25_5_vat : 0,
      summary.sum_with_25_5_tax ? summary.sum_with_25_5_tax : 0
    ],
    [
      'Myynti 24%',
      summary.sum_without_24_tax ? summary.sum_without_24_tax : 0,
      summary.sum_24_vat ? summary.sum_24_vat : 0,
      summary.sum_with_24_tax ? summary.sum_with_24_tax : 0
    ],
    [
      'Myynti 14%',
      summary.sum_without_14_tax ? summary.sum_without_14_tax : 0,
      summary.sum_14_vat ? summary.sum_14_vat : 0,
      summary.sum_with_14_tax ? summary.sum_with_14_tax : 0
    ],
    [
      'Myynti 10%',
      summary.sum_without_10_tax ? summary.sum_without_10_tax : 0,
      summary.sum_10_vat ? summary.sum_10_vat : 0,
      summary.sum_with_10_tax ? summary.sum_with_10_tax : 0
    ],
    [
      'Myynti 0%',
      summary.sum_without_0_tax ? summary.sum_without_0_tax : 0,
      0,
      summary.sum_with_0_tax ? summary.sum_with_0_tax : 0
    ],
    [
      'Rakennusalan Myynti',
      summary.sum_building_construction_0_tax
        ? summary.sum_building_construction_0_tax
        : 0,
      0,
      summary.sum_building_construction_0_tax
        ? summary.sum_building_construction_0_tax
        : 0
    ]
  ]

  // Create Workbook and Worksheet
  const workbook = new ExcelJS.Workbook()
  workbook.creator = 'Me'
  workbook.lastModifiedBy = 'Her'
  const invoicesWorksheet = workbook.addWorksheet('Invoices')
  const summaryWorksheet = workbook.addWorksheet('Summary')

  // Invoices Worksheet Header
  invoicesWorksheet.mergeCells('A2:M2')
  const invoicesHeaderCell = invoicesWorksheet.getCell('A2')
  invoicesHeaderCell.font = {
    name: 'Times New Roman',
    family: 4,
    size: 20,
    underline: true,
    bold: true
  }
  invoicesWorksheet.views = [
    { state: 'frozen', xSplit: 0, ySplit: 5, topLeftCell: 'A6' }
  ]
  invoicesHeaderCell.width = 5
  invoicesHeaderCell.value = 'Invoices Report'

  // Summary Worksheet Header
  summaryWorksheet.mergeCells('A2:D2')
  const summaryHeaderCell = summaryWorksheet.getCell('A2')
  summaryHeaderCell.font = {
    name: 'Times New Roman',
    family: 4,
    size: 20,
    underline: true,
    bold: true
  }
  summaryHeaderCell.width = 5
  summaryHeaderCell.value = 'Invoices Summary Report'

  // Add Invoices Table to worksheet
  invoicesWorksheet.addTable({
    name: 'Invoices',
    ref: 'A5',
    headerRow: true,
    style: {
      theme: 'TableStyleMedium9',
      showRowStripes: true
    },
    columns: invoicesColumns,
    rows: invoicesRows
  })

  // Add Summary Table To Worksheet
  summaryWorksheet.addTable({
    name: 'Summary',
    ref: 'A5',
    headerRow: true,
    style: {
      theme: 'TableStyleMedium9',
      showRowStripes: true
    },
    columns: summaryColumns,
    rows: summaryRows
  })

  // Style The Invoices Table
  for (let i = 0; i < invoicesColumns.length; i++) {
    invoicesWorksheet.getColumn(i + 1).width = 20
  }
  invoicesWorksheet.getRow(5).height = 42.5
  const invoicesTableRows = invoicesWorksheet.getRows(
    6,
    6 + invoicesRows.length
  )
  for (let row of invoicesTableRows) {
    row.height = 30
  }

  // Style the Summary Table
  for (let i = 0; i < summaryColumns.length; i++) {
    summaryWorksheet.getColumn(i + 1).width = 20
  }
  summaryWorksheet.getRow(5).height = 42.5
  const summaryTableRows = summaryWorksheet.getRows(6, 6 + summaryRows.length)
  for (let row of summaryTableRows) {
    row.height = 30
  }

  const handleExport = async () => {
    try {
      const buffer = await workbook.xlsx.writeBuffer()
      saveAs(
        new Blob([buffer], { type: 'application/octet-stream' }),
        'invoices.xlsx'
      )
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Button
      style={{ margin: '20px' }}
      onClick={handleExport}
      variant="contained"
    >
      Download Excel Report
    </Button>
  )
}

export default InvoicePanel
